import * as actionTypes from './actionTypes';
import _ from 'lodash';
import * as api from 'api'
// import {loadStripe} from '@stripe/stripe-js';

//////////////////////
// PAYMENT HANDLERS //
//////////////////////
export const getPaymentMethod = (userId) => {
    const debug = false;

    return dispatch => {
        return api.getPaymentMethod({ userId })
        .then(res => {
            debug && console.log('[getPaymentMethod] Got payment method')
            const paymentMethod = res.data['paymentMethod']
            dispatch({ type: actionTypes.UPDATE_PAYMENT_METHOD, paymentMethod })
        })
        .catch(err => {
            debug && console.log('[getPaymentMethod] Failed to get payment method', err)
        })
    }
}

export const updatePaymentMethod = (paymentMethod) => {
    return { type: actionTypes.UPDATE_PAYMENT_METHOD, paymentMethod }
}

///////////////////////
// CUSTOMER HANDLERS //
///////////////////////
export const getCustomer = (userId) => {
    const debug = false;
    
    return dispatch => {
        return api.getCustomer(userId)
        .then(res => {
            debug && console.log('[getCustomer] Got payment method')
            const customer = res.data['customer']
            dispatch({ type: actionTypes.UPDATE_CUSTOMER, customer })
        })
        .catch(err => {
            debug && console.log('[getCustomer] Failed to get payment method', err)
        })
    }
}

export const updateCustomer = (customer) => {
    return { type: actionTypes.UPDATE_CUSTOMER, customer }
}

/////////////////////
// INVOICE HANLERS //
/////////////////////
export const getInvoices = (userId) => {
    const debug = false;
    
    return dispatch => {
        return api.getInvoices({userId})
        .then(res => {
            debug && console.log('[getInvoices] Got payment method', res.data['invoices'])
            const invoices = res.data['invoices']
            dispatch({ type: actionTypes.UPDATE_INVOICES, invoices: invoices })
        })
        .catch(err => {
            debug && console.log('[getInvoices] Failed to get invoices', err)
        })
    }
}